import { render, staticRenderFns } from "./MoreTeamDialog.vue?vue&type=template&id=2b5760c8&scoped=true&"
import script from "./MoreTeamDialog.vue?vue&type=script&lang=js&"
export * from "./MoreTeamDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreTeamDialog.vue?vue&type=style&index=0&id=2b5760c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5760c8",
  null
  
)

export default component.exports